import { render, staticRenderFns } from "./MyExam.vue?vue&type=template&id=ec8099f6&scoped=true&"
import script from "./MyExam.vue?vue&type=script&lang=js&"
export * from "./MyExam.vue?vue&type=script&lang=js&"
import style0 from "./MyExam.vue?vue&type=style&index=0&id=ec8099f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8099f6",
  null
  
)

export default component.exports